import React, { useReducer } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import { decisionReducer } from "../../../Utils/requestUtils";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";
import { useTranslation } from "react-i18next";

const getConfirmationIcon = (success) => {
  if (success) {
    return (
      <CheckIcon
        className="fraudStatusIcon"
        style={{ color: "#73C580", width: "40px", height: "40px" }}
      />
    );
  } else {
    return (
      <ClearIcon
        className="fraudStatusIcon"
        style={{ color: "#D91A1A", width: "40px", height: "40px" }}
      />
    );
  }
};

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function SaveRuleDialog(props) {
  const { t } = useTranslation();
  let { ruleDraftDefinition, decision } = props;

  const history = useHistory();

  const [dialogState, dispatchDialogState] = useReducer(decisionReducer, {
    isLoading: false,
    isError: false,
    finished: false,
  });

  const handleCloseDialog = () => {
    props.onClose();
    setTimeout(function () {
      dispatchDialogState({ type: "default_state" });
    }, 500);
  };

  const handleFinish = () => {
    dispatchDialogState({ type: "send_request_init" });
    
    let payload = {
      decision: decision
    };
    
    let headersRequest = {
      headers: {
        "COMPANY-KEY": ruleDraftDefinition.company_key,
      },
    };
    setTimeout(function () {
        
      axios
        .put(
          `/dash/rule_engine/rule/${ruleDraftDefinition.rule_key}/rule_draft/decision?environment=${ruleDraftDefinition.environment}`,
          payload,
          headersRequest
        )
        .then((response) => {
          dispatchDialogState({ type: "send_request_success" });
        })
        .catch((error) => {
          if ((error.response || {}).status === 403)
            dispatchDialogState({ type: "send_request_failure_403" });
          else if ((error.response || {}).status === 409)
            dispatchDialogState({ type: "send_request_failure_409" });
          else dispatchDialogState({ type: "send_request_failure" });
        });
    }, 1000);
  };

  const decisionString =
    decision === "approve"
      ? t("Aprovar rascunho de regra")
      : t("Reprovar rascunho de regra");

  if (dialogState.finished && dialogState.isLoading) {
    return (
      <Dialog
        open={props.open}
        onClose={() => history.push("/rules-inbox")}
        keepMounted={false}
        disableBackdropClick
        disableEscapeKeyDown
      >
        <DialogTitle
          style={{ paddingBottom: "0px" }}
          className={["blueText", "normalMediumSize"].join(" ")}
        >
          {t("Salvando Rascunho de Regra")}
        </DialogTitle>
        <DialogContent>
          <div style={{ display: "flex", width: "310px"}}>
            <CircularProgress style={{ margin: "auto" }} />
          </div>
        </DialogContent>
      </Dialog>
    );
  } else if (dialogState.finished) {
    let confirmationData = {
      message: dialogState.message,
      success: !dialogState.isError,
    };
    return (
      <Dialog
        open={props.open}
        onClose={
          confirmationData.success
            ? () => history.push("/rules-inbox")
            : handleCloseDialog
        }
        keepMounted={false}
        disableBackdropClick
      >
        <DialogTitle
          style={{ paddingBottom: "0px" }}
          className={["blueText", "normalMediumSize"].join(" ")}
        >
          {t("Confirmação de Revisão")}
        </DialogTitle>
        <DialogContent>
          <div style={{ width: "310px"}}>
            <div
              className="internalCardContainer"
              style={{
                display: "flex",
                height: "40%",
                justifyContent: "center",
              }}
            >
              {getConfirmationIcon(confirmationData.success)}
            </div>
            <div
              className="internalCardContainer"
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              {confirmationData.message}
            </div>
            <div
              className="internalCardContainer"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <div
                className={[
                  "button",
                  "standard",
                  "normalText",
                  "normalMediumSize",
                ].join(" ")}
                onClick={
                  confirmationData.success
                    ? () => history.push("/rules-inbox")
                    : handleCloseDialog
                }
              >
                {confirmationData.success
                  ? t("VOLTAR À TELA INICIAL")
                  : "FECHAR"}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
  return (
    <Dialog open={props.open} onClose={handleCloseDialog} keepMounted={false}>
      <DialogTitle
        style={{ paddingBottom: "0px" }}
        className={["blueText", "normalMediumSize"].join(" ")}
      >
        {decisionString}
      </DialogTitle>
      <DialogContent>
        <div
          style={{
            width: "366px",
            display: "flex",
            flexDirection: "column",
            marginBottom: "30px",
            alignItems: "center",
          }}
        >
          <div
            className={[
              "internalCardContainer",
              "normalText",
              "normalMediumSize",
            ].join(" ")}
            style={{ width: "90%", textAlign: "center" }}
          >
            {decision === "approve"
              ? "A versão atual da regra original será substituída pelas mudanças feitas nesse rascunho. "
              : "O rascunho de regra será descartado e não poderá ser recuperado. "}
            <strong>{t("Deseja mesmo continuar?")}</strong>
          </div>

          <div
            className="internalCardContainer"
            style={{ display: "flex", marginTop: "10px" }}
          >
            <div
              className={[
                "button",
                "onlyboarder",
                "normalText",
                "normalMediumSize",
              ].join(" ")}
              style={{ width: "180px" }}
              onClick={handleCloseDialog}
            >
              {t("Cancelar")}
            </div>
            <div
              className={[
                "button",
                "standard",
                "normalText",
                "normalMediumSize",
              ].join(" ")}
              style={{ width: "180px" }}
              onClick={handleFinish}
            >
              {t("Confirmar decisão")}
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default SaveRuleDialog;
